import HTTP from '@/utils/http'
class TaskModel extends HTTP {
    /**
    * @description 学生战报上传
    * @param {Object} data
    * @see https://yapi.dayuan1997.com/project/77/interface/api/7906
    */
    postElementUpload(data) {
        return this.post({
            url: `/task/report/element/upload`,
            data: data
        })
    }

    /**
    * @description 战报列表
    * @see https://yapi.dayuan1997.com/project/77/interface/api/7906
    */
    getElementList() {
        return this.get({
            url: `/task/report/element/list`,
        })
    }

    /**
    * @description 战绩点评列表
    * @see https://yapi.dayuan1997.com/project/77/interface/api/7916
    */
    getWeekList() {
        return this.get({
            url: `/task/report/week/list`,
        })
    }

    /**
    * @description 战绩点评已读状态修改
    * @see https://yapi.dayuan1997.com/project/77/interface/api/7906
    */
    postWeekRead(data) {
        return this.post({
            url: `/task/report/week/read`,
            data: data
        })
    }

    /**
    * @description 战报点评已读状态修改
    * @see https://yapi.dayuan1997.com/project/77/interface/api/8071
    */
    postReportRead(data) {
        return this.post({
            url: `/task/report/element/read`,
            data: data
        })
    }

    /**
     * @description 直播指导-获取任务列表
     * @see https://yapi.dayuan1997.com/project/77/interface/api/8106
     */
    getLiveList(params) {
        return this.get({
            url: `/task/live/list`,
            params
        })
    }

    /**
     * @description 直播指导-获取排行榜列表
     * @see https://yapi.dayuan1997.com/project/77/interface/api/8111
     */
    getLiveRank(params) {
        return this.get({
            url: `/task/live/rank`,
            params
        })
    }

    /**
     * @description 直播指导-获取奖励
     * @see https://yapi.dayuan1997.com/project/77/interface/api/8111
     */
    postLivePrize(data) {
        return this.post({
            url: `/task/live/prize`,
            data: data
        })
    }
    /**
     * @description 直播指导-列表已读
     * @see https://yapi.dayuan1997.com/project/77/interface/api/8136
     */
    postLiveRead(data) {
        return this.post({
            url: `/task/live/read`,
            data: data
        })
    }

    /**
    * @description 战报上传奖励
    * @see https://yapi.dayuan1997.com/project/77/interface/api/8391
    */
    postReportPrize(data) {
        return this.post({
            url: `/task/report/element/prize`,
            data: data
        })
    }
}
export default TaskModel